import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { rootSaga } from './store/sagas';
import reducers from './store/reducers';
import { persistStore } from 'redux-persist';
import * as localForage from 'localforage';
import authMiddleware from './middlewares/authMiddleware';
import { completeRehydration } from './store/Config/config.actions';
import { composeWithDevTools } from 'redux-devtools-extension';

// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const router = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
  const middlewares = [
    applyMiddleware(sagaMiddleware),
    applyMiddleware(router),
    applyMiddleware(authMiddleware as any),
  ];

  const store = createStore(
    reducers,
    process.env.NODE_ENV
      ? composeWithDevTools(...middlewares)
      : compose(...middlewares)
  );

  sagaMiddleware.run(rootSaga);
  persistStore(store, { storage: localForage, whitelist: ['auth'] }, () =>
    store.dispatch(completeRehydration())
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.ts